/**
 * App configurations
 */
const plcConfig = {
  by_course: 'https://ayh1d856pl.execute-api.ap-southeast-2.amazonaws.com/PROD/learning-behaviour-by-course',
  places_live_url: 'https://places.plc.sydney',
  armidale_live_url: 'https://connect.plcarmidale.nsw.edu.au',
  api_url: 'https://ayh1d856pl.execute-api.ap-southeast-2.amazonaws.com/PROD/',
  base_url: 'https://ayh1d856pl.execute-api.ap-southeast-2.amazonaws.com/',
  ipstack_api_url: 'https://api.ipstack.com/',
  ipstack_access_key: '5f60ed8910884f5ea1c57b0cf2d00827',
  google_analytics_trackingId: 'UA-92285955-1',
  redirectSignOutUrl:
    'https://auth.plc.sydney/login?client_id=1cnmqv3lbpnlbf8tnrk42n7ovb&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=',
  url: {
    media_bucket_url: 'https://plc-portal-media.s3.amazonaws.com/',
    download_annual_report:
      'https://edumate.plc.nsw.edu.au/plc/PLC_CUSTOM_DEV/PORTALDEV/download.php',
    users: 'users/',
    posts: 'posts/',
    places: 'places/',
    page_types: 'pagetypes/',
    pages: 'pages/',
    upload_editor_image: 'posts/image',
    generate_pdf: 'posts/pdf/',
    post_categories: 'post-categories/',
    calendar: 'calendar/',
    financial_info: 'financial-info/',
    year_info: 'year-info/',
    favorites: 'favorites/',
    key_learning_area: 'key-learning-area/',
    course_units: 'course-units/',
    course_tasks: 'course-tasks/',
    course_classrooms: 'course-classrooms/',
    emergencybroadcast: 'emergencybroadcast/',
    connection_headers: 'connection-headers/',
    connection_pdf_emailtext: 'connection-pdf-emailtext/',
    carerstudents: 'carerstudents',
    send_emails: 'send-emails',
    send_connection_pdf_email: 'send-emails/connection-pdf-email/',
    email_statistics: 'emailstatistics/',
    weeklyemailtext: 'weeklyemailtext/',
    groups: 'groups/',
    weblogs: 'weblogs/',
    docusign: 'docusign',
    docusignboarder: 'docusignboarder',
    docusignpk: 'docusignpk',
    docusignPK2K12: 'docusignPK2K12',
    docusignpkkps: 'docusignpkkps',
    docusign_interview: 'docusign-interview',
    docusignboarder_interview: 'docusignboarder_interview',
    absences: 'absences/',
    absence_percentage: 'absences/percentage/',
    readposts: 'readposts/',
    student_info: 'student-info/',
    send_absent_email: 'send-absent-email/',
    settings: 'settings/',
    my_day_timetable: 'my-day-timetables/',
    teacher_day_timetable: 'teacher-day-timetable/',
    upcoming_tasks: 'upcoming-tasks/',
    student_plot_course: 'plotcourse/',
    student_plot_task: 'plottask/',
    student_academic_report: 'student-academic-reports/',
    student_absence_summary: 'absences/absence-summary/',
    subscribed_users: 'subscribed-users/',
    learning_behaviour: 'student-learning-behaviour/',
    learning_goals: 'student-learning-goals/',
    homeroom_comments: 'homeroom-comments/',
    parent_students: 'users/',
    students:'students',
    studentnotes:'student-notes',
    studentgoals:'student-goals/',
    schoolPsychologyRequest:'school-psychology-request/',
    larningGoalsPDF:'learning-goals-pdf/',
    queuestatistics:'queuestatistics/',
    metrics:'metrics/',
    learningBehaviourByBourse:'learning-behaviour-by-course/',
  },
};
export const config = plcConfig;